import React, { useEffect, useState } from 'react';
import "./PrivacyPolicyPage.css"
const PrivacyPolicyPage = () => {
  const [theme, setTheme] = useState('light');

  useEffect(() => {
    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      setTheme('dark');
    }

    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = (e) => setTheme(e.matches ? 'dark' : 'light');
    mediaQuery.addListener(handleChange);
    return () => mediaQuery.removeListener(handleChange);
  }, []);

  const toggleTheme = () => {
    setTheme(prevTheme => prevTheme === 'light' ? 'dark' : 'light');
  };

  return (
    <div className={`privacy-container ${theme}`}>
      <div className="theme-toggle">
        <button onClick={toggleTheme}>
          {theme === 'light' ? '🌙' : '☀️'}
        </button>
      </div>
      
      <div className="privacy-content">
        <h1>Privacy Policy</h1>
        <p className="last-updated">Last Updated: October 29, 2024</p>

        <section>
          <h2>1. Introduction</h2>
          <p>At JourneyAI, we take your privacy seriously. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our AI-powered journaling application.</p>
        </section>

        <section>
          <h2>2. Information We Collect</h2>
          <h3>2.1 Personal Information</h3>
          <ul>
           
            <li>Usage data and analytics</li>
          </ul>

          <h3>2.2 Journal Content</h3>
          <ul>
            <li>Journal entries and notes that you will agree to share</li>
            <li>Emotional tracking data that you will agree to share</li>
            <li>Writing patterns and preferences that you will agree to share</li>
            <li>AI interaction data</li>
          </ul>
        </section>

        <section>
          <h2>3. How We Use Your Information</h2>
          <p>We use your information to:</p>
          <ul>
            <li>Provide and improve our journaling services</li>
            <li>Generate AI-powered insights and suggestions</li>
            <li>Analyze writing patterns for personalization</li>
            <li>Ensure platform security and prevent abuse</li>
            <li>Communicate updates and relevant information</li>
            <li>Process payments and subscriptions</li>
          </ul>
        </section>

        <section>
          <h2>4. Data Protection</h2>
          <h3>4.1 Security Measures</h3>
          <ul>
            <li>End-to-end encryption of journal entries</li>
            <li>Secure local storage options</li>
            <li>Regular security audits and updates</li>
          </ul>

          <h3>4.2 Data Storage</h3>
          <p>Your journal entries are:</p>
          <ul>
            <li>Stored securely only on your device</li>
            <li>Backed up regularly (if cloud sync is enabled)</li>
            <li>Never shared with third parties without consent</li>
          </ul>
        </section>

        <section>
          <h2>5. AI Technology and Data Processing</h2>
          <p>Our AI features:</p>
          <ul>
            <li>Process journal content to generate insights</li>
            <li>Analyze writing patterns for personalized prompts</li>
            <li>Track emotional patterns (with consent)</li>
          </ul>
        </section>

        <section>
          <h2>6. Data Sharing and Disclosure</h2>
          <p>We may share your information with:</p>
          <ul>
            <li>Service providers (hosting, analytics, payment processing)</li>
            <li>Law enforcement (when legally required)</li>
            <li>Third parties (with explicit consent only)</li>
          </ul>
        </section>

        <section>
          <h2>7. Your Privacy Rights</h2>
          <p>You have the right to:</p>
          <ul>
            <li>Access your personal information</li>
            <li>Correct inaccurate data</li>
            <li>Request data deletion</li>
            <li>Export your data</li>
            <li>Opt-out of data processing</li>
            <li>Withdraw consent at any time</li>
          </ul>
        </section>
        <section>
          <h2>9. International Data Transfers</h2>
          <p>Data may be processed in different countries with appropriate safeguards and compliance with international data protection laws.</p>
        </section>

        <section>
          <h2>10. Changes to Privacy Policy</h2>
          <p>We may update this policy periodically. Users will be notified of significant changes via email or app notification.</p>
        </section>

        <section>
          <h2>11. Contact Information</h2>
          <p>For privacy-related inquiries:</p>
          <div className="contact-info">
            <p>Support Email: nikiemaadama249@gmail.com</p>
          </div>
        </section>

        <section className="compliance-badges">
          <h2>12. Compliance</h2>
          <div className="badges">
            <div className="badge">GDPR Compliant</div>
            <div className="badge">CCPA Compliant</div>
            <div className="badge">PIPEDA Compliant</div>
          </div>
        </section>

        <div className="privacy-footer">
          <p>© 2024 JourneyAI. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;